import { AlertCircle, AlertTriangle, Bell, CheckCircle, Info, LucideIcon } from "lucide-react";

const iconMap: Record<string, LucideIcon> = {
  Bell,
  CheckCircle,
  AlertCircle,
  Info,
  AlertTriangle,
};

export const getIconComponent = (iconName?: string): LucideIcon | undefined => {
  if (!iconName) return undefined;
  return iconMap[iconName];
};
